module.exports = __webpack_public_path__ + "img/enemy_2.94b74a30.png";